var o=function(o){return Boolean(o)&&"object"==typeof o};export{o as isNonNullObject};
//# sourceMappingURL=isNonNullObject.js.map
